<script>
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        yAxes: [{
            ticks: {
                min: 0,
                precision: 0,
            },
        }],
    },
};

export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            default: null,
        },
        options: {
            type: Object,
            default: () => graphOptions,
        },
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};

export function parseTodaysTicketGraphData(todaysTicketGraphData) {
    const ticketData = todaysTicketGraphData.seriesData[0];
    const emergencyData = todaysTicketGraphData.seriesData[1];
    const damagedData = todaysTicketGraphData.seriesData[2];

    const sumArrayElements = (previousValue, currentValue) => previousValue + (currentValue || 0);
    const ticketsCount = ticketData.reduce(sumArrayElements, 0);
    const emergencyCount = emergencyData.reduce(sumArrayElements, 0);
    const damagedCount = damagedData.reduce(sumArrayElements, 0);

    return {
        labels: todaysTicketGraphData.ticks,
        datasets: [
            {
                label: `Tickets (${ticketsCount})`,
                backgroundColor: '#F3A72E',
                data: ticketData,
            },
            {
                label: `Emergency (${emergencyCount})`,
                backgroundColor: '#FF0000',
                data: emergencyData,
            },
            {
                label: `Damaged (${damagedCount})`,
                backgroundColor: '#8E24AA',
                data: damagedData,
            },
        ],
    };
}
</script>
